import { GetServerSideProps, NextPage } from 'next';
import { useEffect } from 'react';

import BackgroundBlobs from '../components/_molecules/BackgroundBlobs/BackgroundBlobs';
import useSignIn from '../hooks/useSignIn';

const ClasslinkLogin: NextPage = () => {
  const { signIn } = useSignIn();

  useEffect(() => {
    signIn({
      provider: 'azure-ad-b2c-classlink-self-join',
      callbackUrl: '/',
      authParams: { domain_hint: 'classlink.com' },
    });
  }, [signIn]);
  return (
    <>
      <BackgroundBlobs />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  // Setting response headers to browsers will save the page in the cache and make login faster.
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=300, stale-while-revalidate=3600',
  );
  return {
    props: {},
  };
};

export default ClasslinkLogin;
